import script from "./PriceshowCategorySection.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceshowCategorySection.vue?vue&type=script&lang=ts&setup=true"

import "./PriceshowCategorySection.vue?vue&type=style&index=0&id=d04f7c64&lang=scss"

const __exports__ = script;

export default __exports__